import { openBrowserAsync } from "expo-web-browser"

export const openConfigureSpam = () => {
  return openBrowserAsync("https://www.ra9plus.jp/guide/delivery_mail_receive_setting")
}
